import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';

registerFragment('chroa-person-card-list', (fragmentElement, configuration, meta) => {});

if (import.meta.hot) {
    import.meta.hot.accept();
}
